import { SnippetyResponseWithChart } from 'hooks/useSnippetyQuery';

export const DEFAULT_IMAGE_WIDTH = '300';

export const createChartUrl = (snippetyData: SnippetyResponseWithChart) => {
  const height = snippetyData.tools.chart.minHeightPerWidth[DEFAULT_IMAGE_WIDTH];
  return `${snippetyData.media}?height=${height}&width=${DEFAULT_IMAGE_WIDTH}`;
};
